import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { ValueDemo } from '../components/ValueDemo';
import { SocialProof } from '../components/SocialProof';
import { HowItWorks } from '../components/HowItWorks';
import { Integrations } from '../components/Integrations';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white" data-id="element-233">
      <Header data-id="element-234" />
      <main data-id="element-235">
        <Hero data-id="element-236" />
        <Features data-id="element-237" />
        <ValueDemo data-id="element-238" />
        <SocialProof data-id="element-239" />
        <HowItWorks data-id="element-240" />
        <Integrations data-id="element-241" />
        <Pricing data-id="element-242" />
        <FAQ data-id="element-243" />
        <CTASection data-id="element-244" />
      </main>
      <Footer data-id="element-245" />
    </div>;
}